module.exports = __webpack_public_path__ + "static/media/expand_more.7b5ac12b.svg";